import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { IBotonBluetooth, IPopulate, IQueryParam } from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-detalles-boton-ble',
  templateUrl: './detalles-boton-ble.component.html',
  styleUrls: [
    '../../../../../componentes/detalle/detalle-pagina.scss',
    './detalles-boton-ble.component.scss',
  ],
  standalone: false,
})
export class DetallesBotonBLEComponent implements OnInit, OnDestroy {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);

  public selectedTab = 0;
  public idBotonBLE = '';
  public botonBLE?: IBotonBluetooth;
  public loading = true;
  private params$?: Subscription;
  private queryParams$?: Subscription;

  /** Las pestañas en orden, por nombre. Tiene que coincidir con la plantilla. */
  private pestanas(): string[] {
    return ['info', 'alertas'];
  }

  public tabChanged(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: this.pestanas()[event.index] ?? event.index },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  /** `tab` por nombre, o por índice (links viejos). */
  private indicePestana(tab: string): number | null {
    if (/^\d+$/.test(tab)) return parseInt(tab);
    const i = this.pestanas().indexOf(tab);
    return i >= 0 ? i : null;
  }

  /**
   * El botón con cliente y modelo. Una sola vez: no tiene datos que cambien
   * solos (antes la página y la pestaña Info lo pedían cada 30 s, cada una
   * por su lado).
   */
  private async listarBotonBLE(): Promise<void> {
    const populate: IPopulate[] = [
      { path: 'cliente', select: 'nombre' },
      { path: 'modeloDispositivo', select: 'marca modelo' },
    ];
    const query: IQueryParam = {
      filter: JSON.stringify({ _id: this.idBotonBLE }),
      populate: JSON.stringify(populate),
      includeChildren: true,
    };
    try {
      const data = await firstValueFrom(this.lista2.botonBles(query));
      this.botonBLE = data?.datos?.[0];
    } catch {
      // No existe o no hay acceso: la página lo dice
      this.botonBLE = undefined;
    }
  }

  /**
   * Carga el botón del id de la ruta. Se llama cada vez que cambia el id:
   * Angular reutiliza el componente al ir de un botón a otro.
   */
  private async cargar(id: string | null): Promise<void> {
    this.loading = true;
    this.botonBLE = undefined;
    this.idBotonBLE = id ?? '';
    await this.listarBotonBLE();
    this.loading = false;
  }

  ngOnInit(): void {
    this.params$ = this.activatedRoute.paramMap.subscribe((params) => {
      void this.cargar(params.get('id'));
    });
    this.queryParams$ = this.activatedRoute.queryParams.subscribe((params) => {
      const indice = params['tab'] ? this.indicePestana(params['tab']) : null;
      if (indice !== null) this.selectedTab = indice;
    });
  }

  ngOnDestroy(): void {
    this.params$?.unsubscribe();
    this.queryParams$?.unsubscribe();
  }
}
